import "./Widget.css";

const Widget = ({ children, className = "", noBackground = false, style }) => {
  return (
    <div
      className={`widget ${className} ${noBackground ? "no-background" : ""}`}
      // style={{
      //   gridColumn: `span ${colSpan}`,
      //   gridRow: `span ${rowSpan}`,
      //   ...style,
      // }}
    >
      {children}
    </div>
  );
};

export default Widget;
